const DipAnimation = () => {
  return null;
};

export default DipAnimation;
